export { default } from './HubFooterView';



// WEBPACK FOOTER //
// ./src/components/views/HubFooterView/index.js